var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline"},[_c('img',{staticStyle:{"max-height":"20px"},attrs:{"src":"/img/load.svg"}})])
}]

export { render, staticRenderFns }